"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLocalizedGlobalize;

var _useWebChatAPIContext = _interopRequireDefault(require("./useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useLocalizedGlobalize() {
  return (0, _useWebChatAPIContext.default)().localizedGlobalizeState;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VMb2NhbGl6ZWRHbG9iYWxpemUiLCJ1c2VXZWJDaGF0QVBJQ29udGV4dCIsImxvY2FsaXplZEdsb2JhbGl6ZVN0YXRlIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaG9va3MvaW50ZXJuYWwvdXNlTG9jYWxpemVkR2xvYmFsaXplLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlTG9jYWxpemVkR2xvYmFsaXplKCkge1xuICByZXR1cm4gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS5sb2NhbGl6ZWRHbG9iYWxpemVTdGF0ZTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBRWUsU0FBU0EscUJBQVQsR0FBaUM7RUFDOUMsT0FBTyxJQUFBQyw2QkFBQSxJQUF1QkMsdUJBQTlCO0FBQ0QifQ==